<h2
  class="tui-text_h2 font-semibold tui-text-03 pl-8 pr-8 mt-[45%] w-auto"
  *ngIf="showInfo"
>
  Please return to Semrush to use the platform
</h2>
